import React from "react";

import IndicatorDashboard from "./IndicatorDashboard";
import {
  fetchLifeQuality,
  fetchLifeQualityRegion,
} from "../../services/infrastructure";

export default function LifeQuality(props) {
  return (
    <IndicatorDashboard
      {...props}
      fetchAggregate={fetchLifeQuality}
      fetchRegion={fetchLifeQualityRegion}
      pairedIds={[4, 5, 6, 7]}
      singleIds={[]}
      sectionTitleKey="infrastructure.lifeQualitySection"
    />
  );
}
